export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_02_loop.4aaa3346.mp4";